import { WarningIcon } from '@phosphor-icons/react'
import * as Dialog from '@radix-ui/react-dialog'
import { DefaultButton } from '../../components/buttons/default-button.tsx'
import { GhostButton } from '../../components/buttons/ghost-button.tsx'
import * as styles from './newer-changes-dialog.css.ts'

type NewerChangesDialogProps = {
  open: boolean
  onCancel: () => unknown
  onCopyChanges: () => unknown
}

export const NewerChangesDialog: React.FC<NewerChangesDialogProps> = ({ open, onCancel, onCopyChanges }) => {
  return (
    <Dialog.Root
      open={open}
      onOpenChange={nextOpen => {
        if (!nextOpen) {
          onCancel()
        }
      }}
    >
      <Dialog.Portal>
        <Dialog.Overlay className={styles.overlay} />
        <Dialog.Content className={styles.content} aria-describedby={undefined}>
          <Dialog.Title className={styles.title}>
            <WarningIcon className={styles.icon} size={32} weight="fill" aria-hidden={true} />
            Newer changes detected
          </Dialog.Title>

          <div className={styles.textGroup}>
            <p className={styles.paragraph}>
              This content has been edited and saved by another user since you started working. Saving now would blindly
              overwrite those changes, so your update was blocked. Copy your changes to the clipboard and try editing
              again after exiting Edit mode.
            </p>
            <p className={styles.paragraph}>Your changes won’t be lost if you copy them now.</p>
          </div>

          <div className={styles.buttons}>
            <GhostButton type="secondary" onClick={onCancel}>
              Cancel
            </GhostButton>
            <DefaultButton onClick={onCopyChanges}>Copy changes</DefaultButton>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
